/* eslint-disable react/jsx-props-no-spreading */
import PackageStatus from 'public-tracker/status/status.container';
import PackageToken from 'public-tracker/token/token.component';
import PackageZipCode from 'public-tracker/zip-code/zip-code.component';
import PackageTrackingIframeWithTrackingKey from 'public-tracker/package-tracking-iframe-with-tracking-key/package-tracking-iframe-with-tracking-key.component';
import PackageTrackingIframeWithoutTrackingKey from 'public-tracker/package-tracking-iframe-without-tracking-key/package-tracking-iframe-without-tracking-key.component';
import React from 'react';
import { Redirect } from 'react-router-dom';
import BlockAccessScreen from 'shared/block-access-screen/block-access-screen.component';
import PrivateRoute from 'shared/routes/private-route.component';
import AdditionalReceivers from './app/classification/additional-receivers/additional-receivers.container';
import AddressClassification from './app/classification/address-classification/address-classification.container';
import Instructions from './app/classification/instructions/instructions.container';
import ConfirmEdition from './app/edit-address/confirm-edition/confirm-edition.container';
import EditAddress from './app/edit-address/edit-address.container';
import Status from './app/package/package.container';
import Success from './app/success/success.container';
import ConfirmDeliveryComponent from './app/package/main-package-info-card/delivery-contestation/confirm-delivery/confirm-delivery.component';
import StartContestComponent from './app/package/main-package-info-card/delivery-contestation/start-contest/start-contest.component';
import EndContestComponent from './app/package/main-package-info-card/delivery-contestation/end-contest/end-contest.component';
import PackageTrackingIframeWithTrackingKeyAndCep from './public-tracker/package-tracking-iframe-with-tracking-key-and-cep/package-tracking-iframe-with-tracking-key-and-cep.component';

const PATH_PACKAGE_TRACKING = '/rastreador';
const PATH_PACKAGE_TRACKING_TRACKING_KEY = `${PATH_PACKAGE_TRACKING}/:trackingKey`;
const PATH_PACKAGE_TRACKING_TRACKING_KEY_AND_CEP = `${PATH_PACKAGE_TRACKING}/cep-novo/:trackingKey`;
const PATH_PACKAGE_TRACKING_ZIP_CODE = `${PATH_PACKAGE_TRACKING}/cep/:trackingKey`;
const PATH_PACKAGE_TRACKING_STATUS = `${PATH_PACKAGE_TRACKING}/:companySecretId/:trackingKey`;
const PATH_PACKAGE_TRACKING_VALIDATOR = `${PATH_PACKAGE_TRACKING_STATUS}/validador`;
const PATH_PACKAGE_BLOCKED_SCREEN = `${PATH_PACKAGE_TRACKING}/erro`;
const PATH_PRIVATE = `${PATH_PACKAGE_TRACKING}/app`;
const PATH_PRIVATE_HOME = `${PATH_PRIVATE}/:packageId`;
const EDIT_ADDRESS = 'alterar-endereco';
const CONFIRM_ADDRESS = 'confirmar';
const INSTRUCTIONS = 'ponto-referencia';
const SUCCESS = 'sucesso';
const CLASSIFICATION = 'classificacao';
const ADDITIONAL_RECEIVERS = 'outros-recebedores';
const CONFIRM_DELIVERY = 'confirmar-entrega';
const CONFLICT_EXPLANATION = 'iniciar-contestacao';
const CONTEST_SEND = 'contestacao-enviada';

const publicRoutes = [
  {
    key: 0,
    path: PATH_PACKAGE_TRACKING,
    component: PackageTrackingIframeWithoutTrackingKey
  },
  {
    key: 1,
    path: PATH_PACKAGE_TRACKING_ZIP_CODE,
    component: PackageZipCode
  },
  {
    key: 2,
    path: PATH_PACKAGE_TRACKING_STATUS,
    component: PackageStatus
  },
  {
    key: 3,
    path: PATH_PACKAGE_TRACKING_VALIDATOR,
    component: PackageToken
  },
  {
    key: 4,
    path: PATH_PACKAGE_BLOCKED_SCREEN,
    component: BlockAccessScreen
  },
  {
    key: 5,
    path: `${PATH_PACKAGE_TRACKING_STATUS}/${CONFIRM_DELIVERY}`,
    component: ConfirmDeliveryComponent
  },
  {
    key: 6,
    path: `${PATH_PACKAGE_TRACKING_STATUS}/${CONFIRM_DELIVERY}/${CONFLICT_EXPLANATION}`,
    component: StartContestComponent
  },
  {
    key: 7,
    path: `${PATH_PACKAGE_TRACKING_STATUS}/${CONFIRM_DELIVERY}/${CONFLICT_EXPLANATION}/${CONTEST_SEND}`,
    component: EndContestComponent
  },
  {
    key: 8,
    path: PATH_PACKAGE_TRACKING_TRACKING_KEY_AND_CEP,
    component: PackageTrackingIframeWithTrackingKeyAndCep
  },
  {
    key: 9,
    path: PATH_PACKAGE_TRACKING_TRACKING_KEY,
    component: PackageTrackingIframeWithTrackingKey
  },
  {
    key: 10,
    path: '*',
    component: () => <Redirect to={PATH_PACKAGE_TRACKING} />
  }
];

const privateRoutes = [
  {
    key: PATH_PRIVATE,
    path: '',
    component: props => <PrivateRoute {...props} component={Status} />
  },
  {
    key: EDIT_ADDRESS,
    path: EDIT_ADDRESS,
    component: EditAddress
  },
  {
    key: CONFIRM_ADDRESS,
    path: CONFIRM_ADDRESS,
    component: ConfirmEdition
  },
  {
    key: SUCCESS,
    path: SUCCESS,
    component: Success
  },
  {
    key: INSTRUCTIONS,
    path: INSTRUCTIONS,
    component: Instructions
  },
  {
    key: CLASSIFICATION,
    path: CLASSIFICATION,
    component: AddressClassification
  },
  {
    key: ADDITIONAL_RECEIVERS,
    path: ADDITIONAL_RECEIVERS,
    component: AdditionalReceivers
  },
  {
    key: 'unKnownPath',
    path: '*',
    component: () => <Redirect to={PATH_PACKAGE_TRACKING} />
  }
];

export {
  PATH_PACKAGE_TRACKING,
  PATH_PACKAGE_TRACKING_ZIP_CODE,
  PATH_PACKAGE_TRACKING_STATUS,
  PATH_PACKAGE_TRACKING_VALIDATOR,
  PATH_PACKAGE_TRACKING_TRACKING_KEY,
  PATH_PACKAGE_TRACKING_TRACKING_KEY_AND_CEP,
  PATH_PACKAGE_BLOCKED_SCREEN,
  PATH_PRIVATE,
  PATH_PRIVATE_HOME,
  ADDITIONAL_RECEIVERS,
  CONFIRM_DELIVERY,
  CONFLICT_EXPLANATION,
  CONTEST_SEND,
  INSTRUCTIONS,
  EDIT_ADDRESS,
  CLASSIFICATION,
  CONFIRM_ADDRESS,
  SUCCESS,
  publicRoutes,
  privateRoutes
};
